{
  "flash": {
    "created": "Created Successfully.",
    "published": "Published Successfully.",
    "cancelled": "Cancelled Successfully.",
    "updated": "Wishlist Updated"
  },
  "new": {
    "title": "Add Class To Change Wishlist"
  },
  "form": {
    "wishlist_type": "Wishlist Type",
    "new_wishlist_label": "New Wishlist",
    "new_wishlist_description": "Create a new wishlist to save this class to.",
    "existing_wishlist_label": "Existing Wishlist",
    "existing_wishlist_description": "Select an existing wishlist to save this class to.",
    "student": "Select a student and class to leave.",
    "duration": "Acceptance Duration",
    "wishlist": "Select a wishlist to save this class to."
  },
  "edit": {
    "title": "Edit Change Wishlist",
    "empty_list": "No Classes to Join",
    "empty_description": "You have no classes in your change wishlist. Add a request by visiting the class search.",
    "empty_action": "Add a Class",
    "list": {
      "rank": "Rank {{index}}",
      "move_up": "Move Up",
      "move_down": "Move Down"
    },
    "cancel": "Cancel Wishlist",
    "leaving_class_name": "Leaving Class",
    "student_name": "Student Name",
    "rankings": "Your Rankings",
    "details": "Details",
    "status": {
      "open": "",
      "cancelled": "This Change Wishlist and all pending requests have been cancelled.",
      "publishing": "This Change Wishlist is currently being published. You cannot make any changes to it. After it settles you may create a new one to apply to more classes.",
      "published": "This Change Wishlist is published. You cannot make any changes to it. Educators now have time to respond.",
      "settled": "This Change Wishlist has settled. You can no longer make changes. The results are now available, and the student may or may not have been placed in a new class. You can create a new wishlist to request additional classes."
    }
  }
}
